import { DateService } from '../../../util/common/date-service/date.service';
import { RegExpService } from '../../../util/common/reg-exp.service';

/**
 * Parses periods from Excel and provides back the standard date type = YYYY-MM-DD.
 *
 * @param period is either excel number date or YYYY-MM-DD or DD.MM.YYYY
 * @return YYYY-MM-DD
 */
export const parseExcelPeriod = (period: string): string => {
  if (!period || period.length > 10 || RegExpService.hasLetters.test(period)) {
    return null;
  }
  if (Number(period)) {
    return DateService.numberToHyphenDate(Number(period));
  }
  if (period[4] === '-') {
    return period;
  }
  if (period[2] === '.') {
    return DateService.dotLocalDateToHyphenDate(period);
  }
  if (RegExpService.dateSeparatedBySlashes.test(period)) {
    return DateService.slashesLocalDateToHyphenDate(period);
  }
  return null;
};

/**
 * Parses numbers from excel:
 * 1) (500) -> -500
 * 2) --500 -> -500
 * 3) 500.00 -> 500
 * 4) 500,000 -> 500000
 *
 * In case @param excelValue is not a number, but a string, then it NaN will be returned.
 * @param excelValue from Excel is kinda sus. 😭
 * @param withFractionDigits tells if a number should be truncated starting with ".".
 */
export const parseExcelNumber = (excelValue: string, withFractionDigits: boolean): number => {
  if (excelValue === undefined || excelValue === null) {
    return null;
  }
  excelValue = String(excelValue);
  if (excelValue.startsWith('(') && excelValue.endsWith(')')) {
    excelValue = '-' + excelValue.substring(1, excelValue.length - 1);
  }
  if (excelValue.startsWith('--')) {
    excelValue = excelValue.substring(1, excelValue.length);
  }
  excelValue = excelValue.replace(new RegExp(/\.(0+)$/), '');
  const numberValue = Number(excelValue);

  if (!withFractionDigits) {
    return removeFractionDigits(numberValue);
  }
  return numberValue;
};

export const parseIsRealized = (isRealized: string): boolean => {
  if (isRealized !== 'active' && isRealized !== 'sold') {
    return null;
  }
  return isRealized === 'sold';
};

/**
 * We need to do rounding, but special orca rounding:
 * 6.5 -> 7
 * -6.5 -> -7
 *
 * @param num rounded up.
 */
export const removeFractionDigits = (num: number): number => {
  if (!num) {
    return num;
  }
  const isNegative = num < 0;
  const value = Math.round(Math.abs(num));
  return isNegative ? -value : value;
};

export const trimIfExists = (s: string): string => (s ? String(s).trim() : s);
